<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          disabled
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-input
          clearable
          v-model.trim="searchCondition.shopName"
          placeholder="请输入门店名称"
          size="small"
          class="ipt mr10"
        ></el-input>
         <el-select
            :disabled="allMerchant.length === 0"
            style="width: 300px"
            size="small"
            clearable
            placeholder="请选择商户"
            v-model="searchCondition.storeName"
            class="mr10"
            filterable
            remote
            :remote-method="remoteMethod"
            >
            <el-option
                v-for="item in storeBasicList"
                :key="item.storeCode"
                :label="item.storeName"
                :value="item.storeName"
            ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        ref="table"
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="商户名称"
          label="商户名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="门店名称"
          label="门店名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="标签名称"
          label="标签名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="应用标签总数量"
          label="应用标签总数量"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      searchCondition: {},
      allMerchant: [],
      storeBasicList: [],
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0
    };
  },
  watch: {},
  created() {
    console.log(this.$route.query);
    this.searchCondition.applyDate = this.$route.query.applyDate;
    this.queryAllMerchant();
  },
  mounted() {
    this.queryList();
  },
  methods: {
      remoteMethod(query) {
      if (query !== "") {
        this.storeBasicList = this.allMerchant.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicList = [];
      }
    },
     async queryAllMerchant() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allMerchant = result;
    },
    // async detail(row) {
    //   const { result } = await this.$store.dispatch("queryGoodsActiveDetail", {
    //     wxshopSkuId: row.wxshopSkuId
    //   });
    //   if (result.length > 0) {
    //     this.$router.push({
    //       name: "SalesActivityDetails",
    //       query: {
    //         goodsSn: row.goodsSn,
    //         wxshopSkuId: row.wxshopSkuId,
    //         id: result[0].id,
    //         type: result[0].auditState,
    //         parentId: result[0].promotionCode.split("-")[0],
    //         mode: "view"
    //       }
    //     });
    //   } else {
    //     this.$message({
    //       message: "该商品暂无活动！",
    //       type: "warning"
    //     });
    //   }
    // },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryShopLabelPageList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
